export const LIST_FLOW_ORDERS = 'LIST_FLOW_ORDERS';
export const LIST_FLOW_ORDERS_SUCCESS = 'LIST_FLOW_ORDERS_SUCCESS';
export const LIST_FLOW_ORDERS_FAILURE = 'LIST_FLOW_ORDERS_FAILURE';

export const SUBSCRIBE_TO_FLOW_ORDERS_UPDATES = 'SUBSCRIBE_TO_FLOW_ORDERS_UPDATES';
export const SUBSCRIBE_TO_FLOW_ORDERS_UPDATES_SUCCESS = 'SUBSCRIBE_TO_FLOW_ORDERS_UPDATES_SUCCESS';
export const SUBSCRIBE_TO_FLOW_ORDERS_UPDATES_FAILURE = 'SUBSCRIBE_TO_FLOW_ORDERS_UPDATES_FAILURE';
